import React, { Component } from 'react'
import Dialog from '@material-ui/core/Dialog'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Slick from '../../Common/Slick'
import './ChangeThumbnail.scss'

import { USER_SOURCE_UPLOAD_POLICY } from '@/utils/Global'
import i18n from '../../../i18n'

class ThumbnailChangeDialog extends Component {

    state = {
        customSelectedIndex: -1,
        previewsSelectedIndex: -1
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedVideo !== nextProps.selectedVideo) {
            this.setState({
                customSelectedIndex: -1,
                previewsSelectedIndex: -1
            })
        }
    }

    handleClickThumbnail = (type, index) => {
        let customSelectedIndex = -1
        let previewsSelectedIndex = -1

        if (type === 'custom') customSelectedIndex = index
        else if (type === 'previews') previewsSelectedIndex = index

        this.setState({ customSelectedIndex, previewsSelectedIndex })
    }

    handleChangeThumbnail = () => {
        const { customSelectedIndex, previewsSelectedIndex } = this.state
        const { selectedVideo } = this.props

        if (!selectedVideo) return

        if (customSelectedIndex !== -1) this.props.handleChangeThumbnail(selectedVideo._id, customSelectedIndex, 'custom')
        else if (previewsSelectedIndex !== -1) this.props.handleChangeThumbnail(selectedVideo._id, previewsSelectedIndex, 'previews')
        else alert(i18n.t("web.changethumbnail.select-video-thumbnail.unselected"))
    }

    render() {
        const {
            isDialogOpened,
            closeDialog,
            thumbnailImg,
            customThumbnails,
            previews
        } = this.props

        const {
            customSelectedIndex,
            previewsSelectedIndex
        } = this.state

        let currentThumbnail = thumbnailImg
        if (customSelectedIndex !== -1) currentThumbnail = customThumbnails[customSelectedIndex]
        else if (previewsSelectedIndex !== -1) currentThumbnail = previews[previewsSelectedIndex]

        return (
            <Dialog
                className='thumbnail-change-dialog'
                open={isDialogOpened}
                onClose={closeDialog}
                maxWidth={false}
            >
                <div className='thumbnail-change-dialog-root'>
                    <div className='thumbnail-change-dialog-body'>
                        <div className='thumbnail-change-dialog-thumbnail'>
                            <img src={currentThumbnail} alt='' />
                        </div>
                        <div className='thumbnail-change-dialog-footer'>
                            <div className='footer-direct-upload-thumbnail'>
                                <div className='upload-heading'>
                                    <div className='heading-main'>
                                    {i18n.t('web.changethumbnail.direct-image-upload')}
                                    </div>
                                    <div className='heading-sub'>
                                    {i18n.t('web.changethumbnail.direct-image-upload.description')
                                        .replace("{LIMIT}", USER_SOURCE_UPLOAD_POLICY.LimitSize.Thumbnail / 1024 / 1024)}
                                    </div>
                                </div>
                                <label className='upload-button' for='custom-thumbnail-file'>
                                    {i18n.t('web.changethumbnail.direct-image-upload.btn')}
                                    <input id='custom-thumbnail-file' style={{ display: 'none' }} type="file" accept="image/jpg,image/jpeg,image/png,image/gif" onChange={this.props.handleAddCustomThumbnail} />
                                </label>
                            </div>
                            <div className='footer-direct-upload-thumbnail-list'>
                                <Slick type='custom' previews={customThumbnails} selectedIndex={customSelectedIndex} handleClickThumbnail={this.handleClickThumbnail} />
                            </div>
                            <div className='footer-choose-video-thumbnail'>
                                <div className='choose-heading'>
                                {i18n.t('web.changethumbnail.select-video-thumbnail')}
                            </div>
                            </div>
                            <div className='footer-choose-video-thumbnail-list'>
                                <Slick type='previews' previews={previews} selectedIndex={previewsSelectedIndex} handleClickThumbnail={this.handleClickThumbnail} />
                            </div>
                            <div className='footer-buttons'>
                                <div className='button-save' onClick={this.handleChangeThumbnail}>
                                {i18n.t('web.changethumbnail.btn.save')}
                                </div>
                                <div className='button-cancel' onClick={closeDialog}>
                                {i18n.t('web.changethumbnail.btn.cancel')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        )
    }
}

export default withMobileDialog()(ThumbnailChangeDialog)